<script setup>
import { computed } from "vue"
import { useRoute } from "vue-router"
import { defineAsyncComponent } from "vue"

const layouts = {
  login: defineAsyncComponent(() =>
    import("@/components/layout/LoginLayout.vue"),
  ),
  default: defineAsyncComponent(() =>
    import("@/components/layout/DefaultLayout.vue"),
  ),
}

import { ModalsContainer } from 'vue-final-modal'


const route = useRoute()

const currentLayout = computed(() => layouts[route.meta.layout || "default"])
</script>

<template>
  <component :is="currentLayout">
    <router-view />
    <ModalsContainer />
  </component>
</template>
